import Axios from "axios";
import { getServerHost } from "../util/host";

const ACCESS_TOKEN_KEY = "koTatouPublicFormAccessToken";

const publicClient = Axios.create({
    baseURL: getServerHost(),
    timeout: 60000,
});

function getAccessToken() {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

function setAccessToken(token) {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
}

function clearAccessToken() {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
}

function accessHeaders() {
    return { Authorization: `Bearer ${getAccessToken() || ""}` };
}

const requestAccess = (pin) =>
    publicClient.post("/public/ko-tatou/access", { pin }).then(response => {
        setAccessToken(response.data.token);
        return response;
    });

const getForm = () =>
    publicClient.get("/public/ko-tatou/form", {
        headers: accessHeaders(),
    });

const submitForm = (response) =>
    publicClient.post(
        "/public/ko-tatou/responses",
        { response },
        { headers: accessHeaders() }
    );

export default {
    clearAccessToken,
    getAccessToken,
    getForm,
    requestAccess,
    submitForm,
};
